import axios, {AxiosResponse} from 'axios'
import {franchiseInvoiceCurrentUsage} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const FRANCHISE_URL = `${API_URL}/franchises`

const getFranchiseInvoiceCurrent = (franchiseId: number): Promise<franchiseInvoiceCurrentUsage> => {
  return axios
    .get(`${FRANCHISE_URL}/${franchiseId}/invoices/current`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const manualPaymentInvoice = (
  franchiseId: number,
  invoiceId: number,
  data: {paid_at: string; observation?: string}
) => {
  return axios
    .post(`${FRANCHISE_URL}/${franchiseId}/invoices/${invoiceId}/manual-payment`, data)
    .then((response: AxiosResponse) => response.data)
}

const chargeInvoice = (franchiseId: number, invoiceId: number, creditCardId?: number) => {
  return axios
    .post(`${FRANCHISE_URL}/${franchiseId}/invoices/${invoiceId}/charge`, {
      credit_card_id: creditCardId,
    })
    .then((response: AxiosResponse) => response.data)
}

export {getFranchiseInvoiceCurrent, manualPaymentInvoice, chargeInvoice}
